/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 */

import {CommonModule} from '@angular/common';
import {ModuleWithProviders, NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

import {TranslateModule} from '@ngx-translate/core';

import {CalendarAbsenceComponent} from './calendar/calendar-absence/calendar-absence.component';
import {CalendarPendingAbsenceComponent} from './calendar/calendar-absence/calendar-pending-absence.component';
import {CalendarMonthViewComponent} from './calendar/calendar-month-view/calendar-month-view.component';
import {CalendarPresenceComponent} from './calendar/calendar-presence/calendar-presence.component';
import {CalendarWeekViewComponent} from './calendar/calendar-week-view/calendar-week-view.component';
import {TimeAndAttendanceComponent} from './time-and-attendance.component';
import {CalendarTooltipComponent, CalendarTooltipDirective} from './time-and-attendance.directive';
import {TimeAndAttendanceService} from './time-and-attendance.service';

import {DateFormatPipe, MomentModule} from 'ngx-moment';
import {ComponentLoaderFactory} from 'ngx-bootstrap/component-loader';
import {PositioningService} from 'ngx-bootstrap/positioning';
import {FormGeneratorModule} from '../../../shared/form-generator/form-generator.module';
import {ModalModule} from '../../../shared/modal/modal.module';
import {PipesModule} from '../../../shared/pipes/pipes.module';
import {UiModule} from '../../../shared/ui/ui.module';
import {WorkflowV2Module} from '../../../shared/workflow/workflow-v2.module';
import {EmployeeVariablesService} from '../variable-elements/employee-variables.service';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    UiModule,
    PipesModule,
    ModalModule,
    TranslateModule,
    MomentModule,
    FormGeneratorModule,
    WorkflowV2Module
  ],
  declarations: [
    CalendarTooltipComponent,
    CalendarPresenceComponent,
    TimeAndAttendanceComponent,
    CalendarWeekViewComponent,
    CalendarMonthViewComponent,
    CalendarAbsenceComponent,
    CalendarPendingAbsenceComponent,
    CalendarTooltipDirective
  ],
  exports: [
    CalendarTooltipComponent,
    CalendarPresenceComponent,
    TimeAndAttendanceComponent,
    CalendarWeekViewComponent,
    CalendarMonthViewComponent,
    CalendarAbsenceComponent,
    CalendarPendingAbsenceComponent,
    CalendarTooltipDirective
  ]
})
export class TimeModule {
  public static forRoot(): ModuleWithProviders<TimeModule> {
    return {
      ngModule: TimeModule,
      providers: [
        TimeAndAttendanceService,
        EmployeeVariablesService,
        ComponentLoaderFactory,
        PositioningService,
        DateFormatPipe
      ]
    };
  }
}
